module.exports = __webpack_public_path__ + "img/makina.c7d42724.svg";